import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux';
import moment from 'moment';
import Notification from "services/Notification";
import PreviewTestModal from '../modals/previewTestModal';

import { Button, Checkbox, ConfigProvider, DatePicker, Form, Input, Modal, Select, TimePicker } from 'antd'
import { ArrowLeftOutlined, CheckCircleOutlined, PlusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import TextArea from 'antd/lib/input/TextArea';
import { getExaminer, getIndexOfTest, getTestChapterList, postTestCreate, storeCreateTestModalData, getSubjects, getTestClassList, removeSelectedSearchSubjs, removeSelectedChapter, setSubjectSectionAction, fetchMarkingSchemeData, clearTestCreateObj, createTestModal, fromCreateNewButton, setFromSectionMarkingScheme, storeMarkedSchemeCardId, resolveAiChapters, importAiQuestions, createAiChapters, createAiSubject, createAiSubjectChapters, fetchAllInstituteStandards } from 'actions/testAdmin';
import { AiOutlineClose } from 'react-icons/ai';
import { useHistory } from 'react-router';
import PageDataLoader from 'components/pageDataLoader';
import { getGenerationSnapshot, clearGenerationSnapshot } from '../components/generationCache';
import CreateMarkingScheme from '../modals/createMarkingScheme';
import EditMarkingSchemeModal from '../modals/editMarkingSchemeModal';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const handleKeyDown = (e) => {
    if (e.key === '+' || e.key === '-') {
        e.preventDefault();
    }
};

let timer = false;
const { Option } = Select;
let selectedTestStartTime = null;
const SectionsNeeded = ({ storeSubjectSection, isSameMarkingScheme, setIsSameMarkingScheme, sectionMeta, storeMarkingSchemeRes, fetchMarkingSchemeData, onSectionChange, section, showFields, childIndex, mainIndex, isCreateMarkingSchemeVisible, setIsCreateMarkingSchemeVisible, setFromSectionMarkingScheme, setIsPreviewModalOpen, onFillSubjectiveSection, storeMarkedSchemeCardId, fromCreateNewButton, hideMarkingScheme }) => {
    const [isModalVisible, setIsModalVisible] = useState(false)
    const sectionState = section;
    const [isEditModal, setIsEditModal] = useState(false)
    useEffect(() => {
        fetchMarkingSchemeData()
    }, [])

    const onFillSection = (mainIndex, index, key, value) => {
        const newSectionState = {
            ...sectionState,
            [key]: value
        }
        onSectionChange(index, newSectionState);
    }

    return (
        <>
            <div className='display-flex m-t-20' style={{ width: '100%' }}>
                <div className='' style={{}}>
                    <div className='bold-600 text-xs m-t-20'>Enter section name</div>
                    <Input
                        className="m-t-5 test-custom-select createTestModalValue"
                        style={{ width: '230%', transition: `${"width 0.5s"}` }}
                        placeholder="Enter section name"
                        onChange={(e) => { onFillSection(mainIndex, childIndex, "name", e.target.value) }}
                    />
                </div>
                {showFields != true ?
                    <>
                        <div className='' style={{ marginLeft: 240 }}>
                            <div className='bold-600 text-xs m-t-20'>Total questions</div>
                            <Input
                                onKeyDown={handleKeyDown}
                                type="number"
                                style={{ width: '105%' }}
                                placeholder="Enter value"
                                className="m-t-5 test-custom-select createTestModalValue"
                                onChange={(e) => { onFillSection(mainIndex, childIndex, "totalQuestions", e.target.value) }}
                            />
                        </div>
                        <div className='' style={{ marginLeft: 40 }}>
                            <div className='bold-600 text-xs m-t-20'>Mandatory questions</div>
                            <Input
                                onKeyDown={handleKeyDown}
                                type="number"
                                placeholder="Enter value"
                                style={{ width: '105%' }}
                                className="m-t-5 test-custom-select createTestModalValue"
                                onChange={(e) => { onFillSection(mainIndex, childIndex, "mandatoryQuestions", e.target.value) }}
                            />
                        </div>
                    </>
                    : null}
            </div>
            {hideMarkingScheme ? null : isSameMarkingScheme && childIndex > 0 ? (<>
                <div className='r-jsb m-t-20'>
                    <div className='bold-600 text-xs' style={{ color: '#636363' }}>Marking scheme</div>
                </div>
                <Input
                    disabled
                    value={storeMarkingSchemeRes.find(el => (sectionState?.markingSchemeId == el.id))?.title}
                />
            </>) : (
                <>
                    <div className='r-jsb m-t-20'>
                        <div className='bold-600 text-xs' style={{ color: '#636363' }}>Marking scheme</div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: "#1089FF", fontWeight: "bold", fontSize: "11px", cursor: "pointer", marginRight: 5 }} onClick={() => { setFromSectionMarkingScheme(true); fromCreateNewButton(false); setIsModalVisible(true) }}><PlusOutlined />{" "}CREATE NEW {" "}</div>
                            <div className='bold-600 text-xs cursor-pointer' style={{ display: "flex", fontSize: "11px", color: '#636363', fontWeight: "bold" }}>
                                <div>
                                    {"  "}|{" "}
                                </div>
                                <div
                                    style={{ marginLeft: 5, cursor: sectionState?.markingSchemeId === "" || sectionState?.markingSchemeId === null || sectionState?.markingSchemeId === undefined ? "not-allowed" : "pointer" }}
                                    onClick={() => {
                                        if (!(sectionState?.markingSchemeId === "" || sectionState?.markingSchemeId === null || sectionState?.markingSchemeId === undefined)) {
                                            storeMarkedSchemeCardId(sectionState?.markingSchemeId?.id ? sectionState?.markingSchemeId?.id : sectionState?.markingSchemeId);
                                            setIsEditModal(true);
                                            setFromSectionMarkingScheme(true);
                                        } else {

                                        }
                                    }}>PREVIEW</div>
                            </div>
                        </div>
                    </div>
                    <div className="dropdown-relative-container">
                        <Select
                            allowClear
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            className="m-t-5 test-custom-select createTestModalValue"
                            style={{ width: '100%', minWidth: '40%' }}
                            placeholder="Select marking scheme"
                            value={sectionState?.markingSchemeId?.title}
                            onChange={(value) => { onFillSection(mainIndex, childIndex, "markingSchemeId", value) }}
                        >

                            {storeMarkingSchemeRes?.length && storeMarkingSchemeRes?.map((item) => (
                                <Option value={item?.id} key={item.id}>{item?.title}</Option>
                            ))}
                        </Select>
                    </div>
                </>)}

            {isModalVisible &&
                <CreateMarkingScheme
                    isCreateMarkingSchemeVisible={isModalVisible}
                    setIsCreateMarkingSchemeVisible={setIsModalVisible}
                    onFillSection={onFillSection}
                    mainIndex={mainIndex}
                    childIndex={childIndex}
                    onFillSubjectiveSection={onFillSubjectiveSection}
                />
            }
            {isEditModal &&
                <EditMarkingSchemeModal
                    isEditModalVisible={isEditModal}
                    setIsEditModalVisisble={setIsEditModal}
                    onFillSection={onFillSection}
                    mainIndex={mainIndex}
                    childIndex={childIndex}
                    onFillSubjectiveSection={onFillSubjectiveSection}
                />
            }
        </>
    )
}

const SectionCount = ({ setSectionVisible, sectionVisible, sectionCountChange, setSectionMeta, index, item, sectionMeta, setIsOther }) => {
    return (
        <div className='display-flex' style={{ width: 50 }}>
            <div onClick={() => { setSectionMeta(index + 1); sectionCountChange(index + 1); setSectionVisible(true), setIsOther(false) }}
                className={`text-xmd bold-600 cursor-pointer
             ${sectionMeta == item ? 'purpleBtnWrap' : 'blankGreyBtnWrap'}`}
                style={{ minWidth: 45, height: 45, borderRadius: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid #E6E6E6', fontFamily: 'roboto' }}
            >

                {item}</div>

        </div>
    )
}

const SubjectSectionsCard = ({
    fetchMarkingSchemeData, storeMarkingSchemeRes, subjectSectionOnChange, id,
    item, testCreateObj, groupedChapters, setChapterSearchSubjectId, setSearchText,
    setSearchTextIndex, updateHandleRender, storeCreateTestModalData, searchedGroupedChapters,
    createTestModalName, removeSelectedChapter, section, storeSubjectSection,
    mainIndex, loaders, setIsPreviewModalOpen, fromCreateNewButton, setFromSectionMarkingScheme,
    storeMarkedSchemeCardId, aiHandoff, onCreateChapters, creatingChapters }) => {

    const isAiSubject = !aiHandoff?.subjectName || !item ||
        String(item).trim().toLowerCase() === String(aiHandoff.subjectName).trim().toLowerCase();

    const [sectionMeta, setSectionMeta] = useState(null);
    const [subjectSection, setSubjectSection] = useState(storeSubjectSection)
    const [sectionVisible, setSectionVisible] = useState(false);
    const [isCreateMarkingSchemeVisible, setIsCreateMarkingSchemeVisible] = useState(false);
    const [isEditModalVisible, setIsEditModalVisisble] = useState(false)
    const [isSameMarkingScheme, setIsSameMarkingScheme] = useState(false)
    const [allQuesMandatory, setAllQuesMandatory] = useState(false)
    const [fillMandatory, setMandatory] = useState()
    const [isOther, setIsOther] = useState(false)
    const [storeSection, setStoreSection] = useState(0)
    const [error, setError] = useState(false);

    useEffect(() => {
        setSubjectSection(storeSubjectSection)
    }, [storeSubjectSection])

    useEffect(() => {
        if (!section) {
            setSectionMeta(null);
            setSectionVisible(false);
            setAllQuesMandatory(false)
        }
    }, [section])

    const onFillSubjectiveSection = (index, key, value) => {
        const newSubjectSection = {
            ...subjectSection,
            [key]: value
        }
        setSubjectSection(newSubjectSection);
        subjectSectionOnChange(index, newSubjectSection);
    }
    const onSectionChange = (sectionIndex, value) => {
        const newSectionsArr = [
            ...subjectSection?.sections?.slice(0, sectionIndex),
            value,
            ...subjectSection?.sections?.slice(sectionIndex + 1)
        ];
        if (isSameMarkingScheme) {
            newSectionsArr.forEach((section) => {
                section.markingSchemeId = newSectionsArr[0]?.markingSchemeId;
            })
        }
        onFillSubjectiveSection(mainIndex, "sections", newSectionsArr)

    }
    const sameForAll = () => {
        const newSectionsArr = subjectSection?.sections?.length ? [...subjectSection?.sections] : [];
        if (!isSameMarkingScheme) {
            newSectionsArr.forEach((section) => {
                section.markingSchemeId = newSectionsArr[0]?.markingSchemeId;
            })
        }
        onFillSubjectiveSection(mainIndex, "sections", newSectionsArr)
    }
    const sectionCountChange = (count) => {
        if (subjectSection?.sections?.length > count) {
            onFillSubjectiveSection(mainIndex, 'sections', subjectSection?.sections?.slice(0, count))
        } else if (!subjectSection?.sections || subjectSection?.sections?.length < count) {
            const newSections = Array(count - (subjectSection?.sections ? subjectSection?.sections?.length : 0))?.fill()?.map(el => ({}))
            onFillSubjectiveSection(mainIndex, 'sections', [...(subjectSection?.sections ? subjectSection?.sections : []), ...newSections])
        }
    }
    useEffect(() => {
        if (fillMandatory === undefined || fillMandatory === '') {
            onFillSubjectiveSection(mainIndex, "mandatoryQuestions", storeSubjectSection?.totalQuestions)
        }
        setMandatory(undefined)
    }, [, storeSubjectSection?.totalQuestions,])
    const validateInput = (value) => {
        if (value < 7) {
            setError(true);
            console.log("AA,hree");
        } else {
            setError(false);
            setSectionMeta(parseInt(value)); setSectionVisible(true)
            //   console.log("AA,hree1");
        }
    };

    return (
        <>
            <div style={{ backgroundColor: '#FFFFFF', border: '1px solid #E4E4E4', height: 'fit-content', width: '100%', borderRadius: 8, marginTop: '20px' }}>
                <div className='p-20'>
                    <div className='r-jsb' style={{ width: '100%' }}>
                        <div className='bold-600 text-xmd' style={{ color: '#636363' }}>{item}</div>
                        <div className='display-flex' style={{ marginRight: -5 }}>

                            {section === false ?
                                <></> :
                                <div className='display-flex m-r-20'>
                                    {
                                        sectionMeta && sectionMeta >= 2 && usesMarkingScheme(testCreateObj?.testType) ?
                                            <>
                                                <Checkbox style={{ fontSize: 5, marginTop: -3 }} onChange={(e) => { onFillSubjectiveSection(mainIndex, "sameMarkingScheme", e.target.checked), setIsSameMarkingScheme(!isSameMarkingScheme), sameForAll() }}></Checkbox>
                                                <div className='m-l-5 text-xs' style={{ color: '#191919', }}>Same marking scheme for all sections</div>
                                            </>
                                            : null
                                    }
                                </div>
                            }

                            <div className='display-flex' style={{ justifyContent: "flex-end" }}>
                                <Checkbox style={{ fontSize: 5, marginTop: -3 }} checked={allQuesMandatory} /* defaultChecked={(e)=>e.target.checked} */ onChange={(e) => {
                                    setAllQuesMandatory(e.target.checked); onFillSubjectiveSection(mainIndex, "allQuestionMandatory", e.target.checked),
                                        onFillSubjectiveSection(mainIndex, "totalQuestions", e.target.value)

                                }}></Checkbox>
                                <div className='m-l-5 text-xs' style={{ color: '#191919', }}>All questions are mandatory</div>
                            </div>
                        </div>
                    </div>
                    {
                        testCreateObj.syllabus != '' && testCreateObj.syllabus != undefined && testCreateObj.syllabus != 'Full' && testCreateObj?.subjectName?.length > 0 && groupedChapters != undefined && Object.keys(groupedChapters)?.length > 0 && testCreateObj.standardId?.length > 0 ?
                            <>
                                {
                                    Object.keys(groupedChapters)?.map((subjectId) => (
                                        <>
                                            {parseInt(subjectId) === parseInt(id) ?
                                                <div>

                                                    <div className="text-xs color-black bold-600 m-b-5 m-t-20">{testCreateObj.syllabus === "Chapter" ? `${groupedChapters[subjectId]?.subjectName} Chapter` : `${groupedChapters[subjectId]?.subjectName} Chapter(s)`} <span style={{ color: 'red' }}>*</span></div>
                                                    <div className="dropdown-relative-container">
                                                        <Select
                                                            disabled={(aiHandoff?.active || (createTestModalName === 'test-edit' && testCreateObj.totalQuestions > 0) || (createTestModalName === 'test-clone') || testCreateObj.class === '' || testCreateObj.class == undefined || (testCreateObj.syllabus === "Chapter" && testCreateObj.chapterList?.length >= 1)) ? true : false}
                                                            showSearch
                                                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                            value={testCreateObj.syllabus === 'Chapter' ? `Search ${groupedChapters[subjectId].subjectName} chapter` : `Search ${groupedChapters[subjectId].subjectName} Chapter(s)`}
                                                            className='test-custom-select createTestModalValue'
                                                            placeholder={testCreateObj.syllabus === 'Chapter' ? 'Search chapter' : 'Search Chapter(s)'}
                                                            style={{ width: '100%', color: "#AEAEAE", cursor: aiHandoff?.active ? 'not-allowed' : undefined }}
                                                            defaultActiveFirstOption={false}
                                                            showArrow={true}
                                                            loading={loaders?.modalChapterLoader}
                                                            filterOption={false}
                                                            onSearch={(text) => {
                                                                setChapterSearchSubjectId(subjectId);
                                                                setSearchText(text);
                                                                setSearchTextIndex('chapters');
                                                                updateHandleRender(true)
                                                            }}
                                                            onSelect={(text, value) => {
                                                                storeCreateTestModalData('chapters', { id: value.value[0], name: value.children, subjectId: value.value[1] });
                                                            }
                                                            }
                                                            notFoundContent={null}
                                                        >
                                                            {searchedGroupedChapters[subjectId]?.chapters?.map((item, index) => {
                                                                if (!item?.name || !item.name.trim() || testCreateObj.chapterList?.map((item) => item.id).includes(item.id)) {
                                                                    return null
                                                                }
                                                                return <Option className="createTestModalDropdown" key={item.id} value={[item.id, item.subjectId]}>{item.name}</Option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                </div>
                                                : null}
                                            {testCreateObj.subjectName?.length
                                                ?
                                                <div className='flex-wrap r-ac'>
                                                    {testCreateObj.chapterList?.map((item, index) => {
                                                        if (groupedChapters[subjectId].chapters?.map(chapterObj => chapterObj.id)?.includes(item.id)) {
                                                            return (
                                                                <div>
                                                                    {
                                                                        parseInt(subjectId) === parseInt(id) ?
                                                                            <div key={index} className={`shadow-box white p-l-10 p-r-10 p-t-5 p-b-5 m-r-15 m-t-15 r-ac ${aiHandoff?.active ? 'ai-prefilled-tag' : ''}`} style={{ background: '#594099', cursor: aiHandoff?.active ? 'not-allowed' : 'default' }}>

                                                                                <div className='text-xs'>{item.name}</div>
                                                                                {
                                                                                    (createTestModalName === 'test-edit' && testCreateObj.totalQuestions > 0) || createTestModalName === 'test-clone' || aiHandoff?.active
                                                                                        ? null
                                                                                        :
                                                                                        <AiOutlineClose onClick={((createTestModalName === 'test-edit' && testCreateObj.totalQuestions > 0) || (createTestModalName === 'test-clone'))
                                                                                            ? () => { }
                                                                                            : () => { removeSelectedChapter(item.id); }}
                                                                                            className='m-l-10 text-xs cursor-pointer' />
                                                                                }
                                                                            </div> :
                                                                            null}
                                                                </div>
                                                            )
                                                        }
                                                        return null
                                                    })}
                                                </div>
                                                : null}
                                        </>
                                    ))
                                }
                            </>
                            : null
                    }
                    {/* Outside the chapter list above: that list only renders for a subject
                        that already has chapters in this batch, and a subject with none is
                        exactly the one that needs the generated chapters added. */}
                    {isAiSubject && aiHandoff?.active && aiHandoff?.unmatchedChapterNames?.length > 0 &&
                        testCreateObj.syllabus != 'Full' && testCreateObj.standardId?.length > 0 ? (
                        <div className='m-t-15 m-b-5'>
                            {!groupedChapters?.[id]?.chapters?.length && (
                                <div className='text-xs' style={{ color: '#636363', marginBottom: 8 }}>
                                    {item} has no chapters in this batch yet. Add the generated ones to create the test.
                                </div>
                            )}
                            <Button
                                size='small'
                                loading={creatingChapters}
                                className='radius-100'
                                onClick={() => onCreateChapters && onCreateChapters(id)}
                            >
                                ADD {aiHandoff.unmatchedChapterNames.length === 1 ? 'THIS CHAPTER' : `THESE ${aiHandoff.unmatchedChapterNames.length} CHAPTERS`}
                            </Button>
                        </div>
                    ) : null}
                    {section == false ?
                        <>
                            {aiHandoff?.active ? (
                                <>
                                    <div className='r-jsb m-t-20'>
                                        <div className='bold-600 text-xs' style={{ color: '#636363' }}>Marking scheme</div>
                                    </div>
                                    <Input
                                        disabled
                                        className="m-t-5 test-custom-select createTestModalValue"
                                        style={{ width: '100%', cursor: 'not-allowed' }}
                                        value={getAiFullMarkingSummary(aiHandoff) || 'As set on each generated question'}
                                    />
                                </>
                            ) : !usesMarkingScheme(testCreateObj?.testType) ? (
                                <div className='text-xs m-t-20' style={{ color: '#636363' }}>
                                    Marks are entered on each coding question.
                                </div>
                            ) : (
                                <>
                                    <div className='r-jsb m-t-20'>
                                        <div className='bold-600 text-xs' style={{ color: '#636363' }}>Marking scheme</div>
                                        <div style={{ display: "flex" }}>
                                            <div style={{ color: "#1089FF", fontWeight: "bold", fontSize: "11px", cursor: "pointer", marginRight: 5 }} onClick={() => { fromCreateNewButton(true); setFromSectionMarkingScheme(false); setIsCreateMarkingSchemeVisible(true) }}><PlusOutlined />{" "}CREATE NEW {" "}</div>
                                            <div className='bold-600 text-xs cursor-pointer' style={{ display: "flex", fontSize: "11px", color: '#636363', fontWeight: "bold" }}>
                                                <div>
                                                    {"  "}|{" "}
                                                </div>
                                                <div
                                                    style={{ marginLeft: 5, cursor: subjectSection?.markingSchemeId === "" || subjectSection?.markingSchemeId === null || subjectSection?.markingSchemeId === undefined ? "not-allowed" : "pointer" }}
                                                    onClick={
                                                        () => {
                                                            if (!(subjectSection?.markingSchemeId === "" || subjectSection?.markingSchemeId === null || subjectSection?.markingSchemeId === undefined)) {
                                                                storeMarkedSchemeCardId(subjectSection?.markingSchemeId?.id ? subjectSection?.markingSchemeId?.id : subjectSection?.markingSchemeId);
                                                                setIsEditModalVisisble(true);
                                                                fromCreateNewButton(true)
                                                            } else {

                                                            }
                                                        }}>
                                                    PREVIEW</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dropdown-relative-container">
                                        <Select
                                            allowClear
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                            className="m-t-5 test-custom-select createTestModalValue"
                                            style={{ width: '100%', minWidth: '40%' }}
                                            placeholder="Select marking scheme"
                                            value={subjectSection?.markingSchemeId?.title}
                                            onChange={(value) => { onFillSubjectiveSection(mainIndex, "markingSchemeId", value) }}
                                        >
                                            {storeMarkingSchemeRes?.length && storeMarkingSchemeRes?.map((item) => (
                                                <Option value={item?.id} key={item.id}>{item?.title}</Option>
                                            ))}
                                        </Select>
                                    </div>
                                </>
                            )}
                            {allQuesMandatory != true ?
                                <>
                                    <div className='r-jsb m-t-10' style={{ width: '100%' }}>
                                        <div className='flex-1 m-r-20'>
                                            <div className='bold-600 text-xs' style={{ color: '#636363', marginBottom: 5 }}>Total questions</div>
                                            <Input
                                                onKeyDown={handleKeyDown}
                                                type="number"
                                                // Bound so a value seeded from outside the form (an AI
                                                // prefill) is visible. Without it the box reads empty
                                                // while the payload carries a count.
                                                value={storeSubjectSection?.totalQuestions ?? ''}
                                                placeholder="Enter value"
                                                className="m-b-15 test-custom-select createTestModalValue"
                                                style={{ width: '100%', minWidth: '40%' }}
                                                onChange={(e) => {
                                                    onFillSubjectiveSection(mainIndex, "totalQuestions", e.target.value)
                                                }}
                                            />
                                        </div>

                                        <div className='flex-1'>
                                            {console.log("AA-mandatory", fillMandatory, storeSubjectSection?.totalQuestions, storeSubjectSection?.mandatoryQuestions)}
                                            <div className='bold-600 text-xs' style={{ color: '#636363', marginBottom: 5 }}>Mandatory questions</div>
                                            <Input
                                                onKeyDown={handleKeyDown}
                                                type="number"
                                                value={fillMandatory == undefined ? storeSubjectSection?.totalQuestions : storeSubjectSection?.mandatoryQuestions}
                                                placeholder="Enter value"
                                                className="m-b-15 test-custom-select createTestModalValue"
                                                style={{ width: '100%', minWidth: '40%' }}
                                                onChange={(e) => {
                                                    if (e.target.value === undefined) {
                                                        setMandatory(undefined)

                                                    }
                                                    setMandatory(e.target.value)
                                                    onFillSubjectiveSection(mainIndex, "mandatoryQuestions", e.target.value)
                                                }}

                                            />
                                        </div>
                                    </div>
                                </>
                                : null}
                        </>
                        : null
                    }
                    {section == true && sectionMeta != 0 ?
                        <>
                            <div className='' style={{ width: '100%' }}>
                                <div className='bold-600 text-xs m-t-20' style={{ color: '#636363', marginBottom: 5 }}>No of sections needed</div>
                                <div className='display-flex'>
                                    {[1, 2, 3, 4, 5, 6,]?.map((item, index) => {
                                        return (
                                            <>
                                                <SectionCount
                                                    sectionMeta={sectionMeta}
                                                    setSectionMeta={setSectionMeta}
                                                    index={index}
                                                    item={item}
                                                    sectionCountChange={sectionCountChange}
                                                    setSectionVisible={setSectionVisible}
                                                    setIsOther={setIsOther}
                                                />
                                            </>
                                        )
                                    })}
                                    <div
                                        className={`cursor-pointer ${isOther ? 'purpleBtnWrap' : 'blankGreyBtnWrap'}`}
                                        style={{ minWidth: 50, height: 45, borderRadius: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid #E6E6E6', fontFamily: 'roboto' }}
                                        onClick={() => { setIsOther(true); setSectionMeta(null) }}
                                    >others</div>
                                    {isOther ?
                                        <div style={{ marginLeft: "40px", marginTop: "5px" }}>
                                            <Form>
                                                <Form.Item
                                                    label="Input"
                                                    validateStatus={error ? 'error' : ''}
                                                    help={error ? 'Value must be 7 or greater.' : ''}
                                                >
                                                    <Input
                                                        style={{ width: "300px" }} placeholder='Enter values'
                                                        type="number"
                                                        min={6}
                                                        onChange={(e) => { validateInput(e.target.value) }}
                                                    />
                                                </Form.Item>
                                            </Form>
                                        </div>
                                        : null}
                                </div>
                            </div>
                            {sectionMeta > 0 ?
                                <>
                                    {Array(sectionMeta)?.fill()?.map((item, index) => {
                                        return (
                                            <>
                                                {
                                                    sectionVisible ?
                                                        <SectionsNeeded
                                                            showFields={allQuesMandatory}
                                                            section={subjectSection?.sections?.[index]}
                                                            childIndex={index}
                                                            mainIndex={mainIndex}
                                                            onFillSubjectiveSection={onFillSubjectiveSection}
                                                            onSectionChange={onSectionChange}
                                                            storeMarkingSchemeRes={storeMarkingSchemeRes}
                                                            fetchMarkingSchemeData={fetchMarkingSchemeData}
                                                            setIsCreateMarkingSchemeVisible={setIsCreateMarkingSchemeVisible}
                                                            isCreateMarkingSchemeVisible={isCreateMarkingSchemeVisible}
                                                            setFromSectionMarkingScheme={setFromSectionMarkingScheme}
                                                            setIsPreviewModalOpen={setIsPreviewModalOpen}
                                                            storeMarkedSchemeCardId={storeMarkedSchemeCardId}
                                                            fromCreateNewButton={fromCreateNewButton}
                                                            isSameMarkingScheme={isSameMarkingScheme}
                                                            setIsSameMarkingScheme={setIsSameMarkingScheme}
                                                            sectionMeta={sectionMeta}
                                                            storeSubjectSection={storeSubjectSection}
                                                            hideMarkingScheme={!usesMarkingScheme(testCreateObj?.testType)}
                                                        /> : null
                                                }
                                            </>
                                        )
                                    })}
                                </>
                                :
                                <></>}

                        </>
                        : null}
                </div>
            </div>
            {isCreateMarkingSchemeVisible &&
                <CreateMarkingScheme
                    isCreateMarkingSchemeVisible={isCreateMarkingSchemeVisible}
                    setIsCreateMarkingSchemeVisible={setIsCreateMarkingSchemeVisible}
                    onFillSubjectiveSection={onFillSubjectiveSection}
                    mainIndex={mainIndex}
                />
            }
            {isEditModalVisible &&
                <EditMarkingSchemeModal
                    isEditModalVisible={isEditModalVisible}
                    setIsEditModalVisisble={setIsEditModalVisisble}
                    onFillSubjectiveSection={onFillSubjectiveSection}
                    mainIndex={mainIndex}
                />
            }
        </>
    )
}

// Named the way the question editor (/admin-test) names the type each generated
// question is saved as (see AI_TYPE_MAP in actions/testAdmin). The editor has no
// matrix type, so matrix match questions are saved as One Correct Answer.
const AI_QUESTION_TYPE_NAMES = {
    single_mcq: 'One Correct Answer',
    multi_correct_mcq: 'Multiple Correct Answer',
    integer_type: 'Numeric',
    matrix_match: 'One Correct Answer',
    assertion_reason: 'One Correct Answer',
    short_answer_2: 'Subjective',
    short_answer_3: 'Subjective',
    long_answer: 'Subjective',
    case_based: 'Subjective',
};

// Subjective answers are graded by hand, so a test holding any has no result
// date (results publish after grading) and takes a single subject.
const hidesResultDate = (testType) => testType === 'Subjective' || testType === 'Mixed' || testType === 'Coding';
const singleSubjectOnly = (testType) => testType === 'Subjective' || testType === 'Mixed' || testType === 'Coding';
// Coding marks are entered on each question, not taken from a marking scheme
const usesMarkingScheme = (testType) => testType !== 'Coding';

const AI_TEST_TYPE_NAMES = { Objective: 'an Objective test', Subjective: 'a Subjective test', Mixed: 'a Mixed test' };
const AI_WRITTEN_TYPE_KEYS = ['subjective', 'short_answer_2', 'short_answer_3', 'long_answer', 'case_based'];

// "+2 for correct, -0.5 for wrong · Subjective: 5 marks each" -- the generated
// questions keep their own marks, so this only describes what will be saved.
const getAiSubjectiveMarksSummary = (generatedTest) => {
    const marks = [...new Set((generatedTest?.questions || [])
        .filter((q) => AI_WRITTEN_TYPE_KEYS.includes(String(q?.type ?? q?.question_type ?? '').toLowerCase()))
        .map((q) => Number(q?.marks))
        .filter((m) => Number.isFinite(m) && m > 0))];
    if (!marks.length) return '';
    return marks.length === 1 ? `Subjective: ${marks[0]} marks each` : `Subjective: ${marks.sort((a, b) => a - b).join(' / ')} marks`;
};

const getAiFullMarkingSummary = (aiHandoff) => {
    const objectiveTypes = (aiHandoff?.questionTypes || []).filter((t) => !AI_WRITTEN_TYPE_KEYS.includes(t));
    const objective = aiHandoff?.objectiveCount === 0
        ? ''
        : getAiMarkingSummary(aiHandoff?.generatedTest, objectiveTypes);
    return [objective, getAiSubjectiveMarksSummary(aiHandoff?.generatedTest)].filter(Boolean).join(' · ');
};

const aiQuestionTypeLabel = (types) =>
    [...new Set((types || []).map((t) => AI_QUESTION_TYPE_NAMES[t] || t))].join(', ');

const formatAiMarks = (scheme) => {
    if (!scheme || scheme.correct === undefined || scheme.correct === null) return '';
    const neg = scheme.incorrect ?? scheme.negative ?? scheme.negative_marks;
    const negText = neg !== undefined && neg !== null && Number(neg) !== 0 ? `, -${Math.abs(Number(neg))} for wrong` : ', no negative marking';
    return `+${scheme.correct} for correct${negText}`;
};

// Read-only marking summary for an AI-prefilled test. The generated questions are
// saved with their own marks, so this only shows what the backend sent.
const getAiMarkingSummary = (generatedTest, questionTypes) => {
    const byType = generatedTest?.marking_scheme_by_type || generatedTest?._metadata?.marking_scheme_by_type;
    if (byType && typeof byType === 'object') {
        const norm = (s) => String(s).toLowerCase().replace(/[^a-z0-9]/g, '');
        const wanted = (questionTypes || []).map(norm);
        const entries = Object.entries(byType).filter(([key, val]) =>
            formatAiMarks(val) && (!wanted.length || wanted.includes(norm(key))));
        const distinctMarks = [...new Set(entries.map(([, val]) => formatAiMarks(val)))];
        if (distinctMarks.length === 1) return distinctMarks[0];
        if (entries.length > 1) {
            return [...new Set(entries
                .map(([key, val]) => `${AI_QUESTION_TYPE_NAMES[key] || key}: ${formatAiMarks(val)}`))]
                .join(' · ');
        }
    }
    return formatAiMarks(generatedTest?.marking_scheme || generatedTest?._metadata?.marking_scheme);
};

// Shown when the form was seeded from a generation. The point is to be honest
// about what carried over: a silent prefill that quietly dropped three chapters
// is worse than no prefill, because nobody checks a field that looks filled in.
// Subject names compared on lowercase letters and digits only.
const normaliseSubjectName = (name) => String(name ?? '').toLowerCase().replace(/[^a-z0-9]/g, '');

const AiPrefillBanner = ({ aiHandoff, importProgress, onCreateChapters, creatingChapters, onOpenAddSubjectModal, onAddMissingSubject, subjectsWithoutChapters, onAddTopicChapters }) => {
    // A successful create clears the handoff, but the import runs after that and
    // can take a while -- 30 questions is 30 round trips. Keep reporting it, or
    // the page looks idle and the teacher navigates away mid-import.
    const importing = !!importProgress?.total && importProgress.done < importProgress.total;
    if (importing) {
        return (
            <div className='ai-prefill-banner'>
                <div className='ai-prefill-title'>Adding generated questions</div>
                <div className='ai-prefill-line'>
                    {importProgress.done} of {importProgress.total} saved. Stay on this page until it finishes.
                </div>
            </div>
        )
    }
    if (!aiHandoff?.active) return null;
    const isScan = aiHandoff.source === 'scanPdf';
    const requested = (aiHandoff.matchedChapterNames?.length || 0) + (aiHandoff.unmatchedChapterNames?.length || 0);
    const awaitingBatch = !!aiHandoff.pendingChapterNames?.length;
    return (
        <div className='ai-prefill-banner'>
            <div className='ai-prefill-title'>{isScan ? 'Prefilled from your scanned PDF' : 'Prefilled from Aulas AI'}</div>
            <div className='ai-prefill-line'>
                {aiHandoff.subjectResolved
                    ? (aiHandoff.titleProvided ? `Subject, title and syllabus are filled in. ` : `Subject and syllabus are filled in. `)
                    : (aiHandoff.titleProvided ? `Title and syllabus are filled in. ` : `Syllabus is filled in. `)}
                {aiHandoff.fullSyllabus
                    ? `All ${aiHandoff.fullChapterCount} chapters were selected, so this is a Full syllabus test.`
                    : awaitingBatch
                        ? `Choose a batch and the ${aiHandoff.pendingChapterNames.length} generated chapter${aiHandoff.pendingChapterNames.length === 1 ? '' : 's'} will be matched to this institute's syllabus.`
                        : requested > 0
                            ? `${aiHandoff.matchedChapterNames.length} of ${requested} chapters matched.`
                            : `No chapters were selected during generation.`}
            </div>
            {!aiHandoff.subjectResolved && (
                <div className='ai-prefill-warn'>
                    <div>
                        No subject named "{aiHandoff.subjectName}" exists here &mdash; pick one below or add it directly.
                    </div>
                    {onOpenAddSubjectModal && (
                        <div style={{ marginTop: 6 }}>
                            <Button
                                size='small'
                                className='radius-100'
                                onClick={onOpenAddSubjectModal}
                            >
                                ADD "{aiHandoff.subjectName?.toUpperCase()}" SUBJECT
                            </Button>
                            <span style={{ marginLeft: 10, fontSize: 11, color: '#636363' }}>
                                Creates this subject under a selected batch so you can use it immediately.
                            </span>
                        </div>
                    )}
                </div>
            )}
            {aiHandoff.subjectResolved && aiHandoff.missingSubjects?.length > 0 && (
                <div className='ai-prefill-warn'>
                    <div>
                        Not a subject here: {aiHandoff.missingSubjects.map((m) => m.name).join(', ')}. Their questions are
                        left out of the test unless the subject is added.
                    </div>
                    {onAddMissingSubject && aiHandoff.missingSubjects.map((m) => (
                        <Button
                            key={m.name}
                            size='small'
                            className='radius-100'
                            style={{ marginTop: 6, marginRight: 8 }}
                            onClick={() => onAddMissingSubject(m)}
                        >
                            ADD "{m.name.toUpperCase()}" SUBJECT
                        </Button>
                    ))}
                </div>
            )}
            {subjectsWithoutChapters?.length > 0 && (
                <div className='ai-prefill-warn'>
                    <div>
                        No chapters in this batch for: {subjectsWithoutChapters.map((s) => s.name).join(', ')}. A Full
                        test needs at least one chapter in every subject, so CREATE stays off until each has one.
                    </div>
                    {onAddTopicChapters && subjectsWithoutChapters.map((s) => (
                        <div key={s.id} style={{ marginTop: 6 }}>
                            <Button
                                size='small'
                                className='radius-100'
                                loading={creatingChapters}
                                disabled={!s.topics.length}
                                onClick={() => onAddTopicChapters(s)}
                            >
                                ADD {s.name.toUpperCase()} TOPICS AS CHAPTERS
                            </Button>
                            <span style={{ marginLeft: 10, fontSize: 11, color: '#636363' }}>
                                {s.topics.length
                                    ? s.topics.join(', ')
                                    : 'No generated topics for this subject: add a chapter from the syllabus screen.'}
                            </span>
                        </div>
                    ))}
                </div>
            )}
            {aiHandoff.unmatchedChapterNames?.length > 0 && (
                <div className='ai-prefill-warn'>
                    <div>
                        Not in this subject's syllabus: {aiHandoff.unmatchedChapterNames.join(', ')}.
                    </div>
                </div>
            )}
            {aiHandoff.questionCount > 0 && (
                <div className='ai-prefill-line' style={{ marginTop: 6 }}>
                    {aiHandoff.questionCount} generated {aiHandoff.questionTypes?.length ? `(${aiQuestionTypeLabel(aiHandoff.questionTypes)}) ` : ''}question{aiHandoff.questionCount === 1 ? '' : 's'} will be added once you press CREATE
                    {aiHandoff.subjectiveCount > 0
                        ? <> &mdash; <b style={{ color: '#463278' }}>{aiHandoff.objectiveCount > 0 ? `${aiHandoff.objectiveCount} objective + ${aiHandoff.subjectiveCount} subjective, ` : ''}as {AI_TEST_TYPE_NAMES[aiHandoff.testType] || 'a test'}</b>.</>
                        : '.'}
                </div>
            )}
        </div>
    )
}

const CreateTest = ({
    postTestCreate, fetchMarkingSchemeData, storeMarkingSchemeRes,
    storeSubjectSection, setSubjectSectionAction, removeSelectedChapter,
    searchedGroupedChapters, groupedChapters, stdsForCreatingTest,
    removeSelectedSearchSubjs, createTestModalSource,
    getTestClassList, createTestModalName, testCreateObj,
    storeCreateTestModalData, getExaminer, getExaminerArr,
    userType, getSubjects, getIndexOfTest, getSubjectsBool,
    getSubjectsArr, getTestChapterList, selectedClassroom, getExaminerBool,
    loaders, clearTestCreateObj, listViewType, createTestModal,
    fromCreateNewButton, setFromSectionMarkingScheme, storeMarkedSchemeCardId, user, isFromClassRoomDetails, selectedSection,
    aiHandoff, chaptersForCreatingTest, resolveAiChapters, importAiQuestions, createAiChapters,
    createAiSubject, createAiSubjectChapters, fetchAllInstituteStandards }) => {

    const bodyStyle = {
        background: "#FAFAFA",
        width: "calc(100% + 40px)",
        height: "calc(100% + 40px)",
        padding: 20,
        margin: -20,
        color: "FFFFFF",
    };
    const [createSaveLoader, setCreateSaveLoader] = useState(false)
    const [sectionValue, setSectionValue] = useState(false);
    const [isAddSubjectModalVisible, setAddSubjectModalVisible] = useState(false);
    const [selectedBatchForSubject, setSelectedBatchForSubject] = useState(null);
    const [selectedBatchLabelForSubject, setSelectedBatchLabelForSubject] = useState('');
    const [availableBatches, setAvailableBatches] = useState([]);
    const [loadingBatches, setLoadingBatches] = useState(false);
    // One of several generated subjects being added next to the others; null for the single-subject case.
    const [missingSubjectToAdd, setMissingSubjectToAdd] = useState(null);
    const subjectNameToAdd = missingSubjectToAdd?.name || aiHandoff?.subjectName;

    const handleOpenAddSubjectModal = (missing) => {
        const isMissing = !!missing?.name;
        setMissingSubjectToAdd(isMissing ? missing : null);
        setAddSubjectModalVisible(true);
        // The other subjects are already on the test's batch: the new one goes there too.
        if (isMissing && testCreateObj?.standardId?.length) {
            const std = Array.isArray(testCreateObj.standardId) ? testCreateObj.standardId[0] : testCreateObj.standardId;
            setSelectedBatchForSubject(Number(std));
            setSelectedBatchLabelForSubject(testCreateObj?.class || '');
        }
        if (isFromClassRoomDetails && selectedSection?.id) {
            setSelectedBatchForSubject(selectedSection.id);
            setSelectedBatchLabelForSubject(`${selectedSection.std || ''} - ${selectedSection.section || ''}`);
        }
        setLoadingBatches(true);
        if (fetchAllInstituteStandards) {
            fetchAllInstituteStandards((batches) => {
                setLoadingBatches(false);
                setAvailableBatches(batches || []);
            });
        }
    };

    const handleCreateSubjectSubmit = () => {
        if (!selectedBatchForSubject) {
            Notification.error('Batch required', 'Please select a batch to add this subject to.');
            return;
        }
        createAiSubject(
            subjectNameToAdd,
            selectedBatchForSubject,
            selectedBatchLabelForSubject,
            (ok) => {
                if (!ok) {
                    Notification.error('Could not create subject', 'Please check permissions or create the subject manually in the classroom.');
                    return;
                }
                setAddSubjectModalVisible(false);
                setMissingSubjectToAdd(null);
                Notification.success(
                    'Subject added and selected',
                    `Subject "${subjectNameToAdd}" has been added to ${selectedBatchLabelForSubject || 'batch'} and selected.`
                );
            },
            missingSubjectToAdd
                ? {
                    append: true,
                    totalQuestions: missingSubjectToAdd.totalQuestions,
                    chapterNames: missingSubjectToAdd.topics,
                    onChapters: ({ ok }) => {
                        if (!ok) {
                            Notification.error(
                                'Chapters not added',
                                `"${missingSubjectToAdd.name}" has no chapters, so its questions cannot be saved. Add a chapter to it from the syllabus screen.`
                            );
                        }
                    },
                }
                : undefined
        );
    };
    const handleCreateChapters = (targetSubjectId) => {
        createAiChapters((ok, result) => {
            if (!ok) {
                Notification.error('Could not add chapters', 'Add them from the syllabus screen, or leave them out of this test.');
                return;
            }
            if (result?.missing?.length) {
                Notification.error(
                    'Some chapters were not added',
                    `The server accepted the request but ${result.missing.join(', ')} did not appear in this subject. Add them from the syllabus screen.`
                );
                return;
            }
            Notification.success(
                'Chapters added and selected',
                `${result?.added?.join(', ')} — now showing as chips below. The dropdown hides chapters that are already selected.`
            );
        }, targetSubjectId);
    };
    // POST /test refuses a Full test while any subject has no chapter in the batch ("There are no chapters in
    // some of the subjects for this class"). Name those subjects here, with their generated topics to add.
    const subjectsWithoutChapters = (() => {
        if (!aiHandoff?.active || testCreateObj?.syllabus !== 'Full') return [];
        if (!testCreateObj?.standardId?.length || !!loaders?.modalChapterLoader) return [];
        if (!Array.isArray(chaptersForCreatingTest)) return [];
        const ids = Array.isArray(testCreateObj?.subjectId) ? testCreateObj.subjectId : [];
        const names = Array.isArray(testCreateObj?.subjectName) ? testCreateObj.subjectName : [];
        const handed = aiHandoff?.generatedTest?.questions || [];
        return ids
            .map((id, index) => ({ id: String(id), name: names[index] || '' }))
            .filter((s) => !chaptersForCreatingTest.some((c) => String(c?.subjectId) === s.id))
            .map((s) => {
                const key = normaliseSubjectName(s.name);
                const topics = Array.from(new Set(handed
                    .filter((q) => {
                        const other = normaliseSubjectName(q?.subject);
                        return other && key && (other === key || other.includes(key) || key.includes(other));
                    })
                    .map((q) => String(q?.chapter || q?.topic || '').trim())
                    .filter(Boolean)));
                return { ...s, topics };
            });
    })();
    const handleAddTopicChapters = (subject) => {
        const std = Array.isArray(testCreateObj?.standardId) ? testCreateObj.standardId[0] : testCreateObj?.standardId;
        createAiSubjectChapters(subject.id, std, subject.topics, ({ ok }) => {
            if (!ok) {
                Notification.error('Could not add chapters', `Add a chapter to "${subject.name}" for this batch from the syllabus screen.`);
            }
        });
    };
    const fromCreateTest = true;
    const isCreateDisabled = (() => {
        if (subjectsWithoutChapters.length) return true;
        if (!testCreateObj?.testType) return true;
        if (!testCreateObj?.title || testCreateObj.title.trim() === "") return true;
        if (!testCreateObj?.teacherName || testCreateObj.teacherName.trim() === "") return true;
        if (!testCreateObj?.syllabus) return true;
        if (!testCreateObj?.subjectName || testCreateObj.subjectName.length === 0) return true;
        const batchVal = isFromClassRoomDetails ? (selectedSection?.std + ' - ' + selectedSection?.section) : testCreateObj?.class;
        if (!batchVal || batchVal === 'Select batch' || batchVal.trim() === "") return true;
        if (!testCreateObj?.heldDate || testCreateObj.heldDate === 'Invalid date' || testCreateObj.heldDate === "") return true;
        if (!testCreateObj?.heldStartTime || testCreateObj.heldStartTime === 'Invalid date' || testCreateObj.heldStartTime === "") return true;
        if (!testCreateObj?.heldEndTime || testCreateObj.heldEndTime === 'Invalid date' || testCreateObj.heldEndTime === "") return true;
        if (!hidesResultDate(testCreateObj.testType)) {
            if (!testCreateObj?.resultDate || testCreateObj.resultDate === 'Invalid date' || testCreateObj.resultDate === "") return true;
            if (!testCreateObj?.resultTime || testCreateObj.resultTime === 'Invalid date' || testCreateObj.resultTime === "") return true;
        }
        if (!testCreateObj?.instruction || testCreateObj.instruction.trim() === "") return true;
        if (testCreateObj.syllabus !== 'Full') {
            if (!testCreateObj?.chapterList || testCreateObj.chapterList.length === 0) return true;
        }
        return false;
    })();

    const PageHeader = () => {
        const history = useHistory();
        return (
            <div style={{ width: '100%' }}>
                <div className='r-jsb p-10' style={{ width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <ArrowLeftOutlined
                            onClick={() => {
                                setSubjectSectionAction([]);
                                // Came from Aulas AI: go back to the generated questions
                                // (restored from the snapshot) instead of the test list.
                                // Came from Scan PDF: go back to the reviewed questions, which that screen kept. The
                                // page's own "from" survives a refresh, when the handoff in memory does not.
                                if ((aiHandoff?.active && aiHandoff?.source === 'scanPdf') || location?.state?.from === 'scanPdf') {
                                    history.push({ pathname: '/scan-pdf-test', state: { key: location?.state?.key, resumeScan: true } });
                                } else if (aiHandoff?.active && getGenerationSnapshot()) {
                                    history.push({ pathname: '/generate-test-aulas-ai', state: { key: location?.state?.key } });
                                } else {
                                    history.push('/test');
                                }
                                clearTestCreateObj();
                            }}
                            style={{ fontSize: 18, marginRight: 12, cursor: 'pointer', color: '#191919' }}
                        />
                        <div className='bold-700 text-md' style={{ fontFamily: 'roboto' }}>Create test manually</div>
                    </div>
                    <div style={{ display: "flex" }}>
                        <Button
                            className='blankGreyBtnWrap radius-100 m-r-30'
                            style={{ width: 120, marginRight: "25px" }}
                            onClick={() => { setSubjectSectionAction([]); clearGenerationSnapshot(); history.push('/test'); clearTestCreateObj(); }}
                        >CANCEL</Button>
                        <Button
                            // The import runs after postTestCreate has already
                            // released its own loader, so keep the button busy
                            // for the whole of it.
                            loading={createSaveLoader || !!loaders?.aiImportLoader}
                            disabled={isCreateDisabled || !!loaders?.aiImportLoader}
                            className='purpleBtnWrap radius-100 purpleButtonHoverEffect'
                            style={{
                                width: 120,
                                cursor: isCreateDisabled ? 'not-allowed' : 'pointer',
                                opacity: isCreateDisabled ? 0.6 : 1,
                                backgroundColor: isCreateDisabled ? '#E6E6E6' : undefined,
                                borderColor: isCreateDisabled ? '#E6E6E6' : undefined,
                                color: isCreateDisabled ? '#AEAEAE' : undefined
                            }}
                            onClick={() => {
                                for (let i = 0; i < storeSubjectSection?.length; i++) {
                                    storeSubjectSection[i].markingSchemeId = storeSubjectSection[i].markingSchemeId?.id ? storeSubjectSection[i].markingSchemeId?.id : storeSubjectSection[i].markingSchemeId ? storeSubjectSection[i].markingSchemeId : storeSubjectSection[i]?.schemeId;
                                    storeSubjectSection[i].id = storeSubjectSection[i].subjId ? storeSubjectSection[i].subjId : storeSubjectSection[i].id;
                                    for (let j = 0; j < storeSubjectSection?.[i]?.sections?.length; j++) {
                                        storeSubjectSection[i].sections[j].markingSchemeId = storeSubjectSection[i].sections[j].markingSchemeId?.id ? storeSubjectSection[i].sections[j].markingSchemeId?.id : storeSubjectSection[i].sections[j].markingSchemeId ? storeSubjectSection[i].sections[j].markingSchemeId : storeSubjectSection[i].sections[j].schemeId
                                    }
                                }
                                // Read off the handoff before creating: a successful
                                // create clears testCreateObj, and the AI slice with it.
                                const aiSnapshot = aiHandoff ? { ...aiHandoff } : null;
                                const aiQuestions = aiSnapshot?.generatedTest?.questions || [];
                                // A Full test has no chapter list; use the batch's chapters instead.
                                const aiChapters = testCreateObj?.syllabus === 'Full'
                                    ? [...(chaptersForCreatingTest || [])]
                                    : [...(testCreateObj?.chapterList || [])];
                                postTestCreate((res) => {
                                    clearGenerationSnapshot();
                                    const goToQuestions = () => {
                                        history.push({
                                            pathname: '/admin-test',
                                            state: location?.state?.key == "fromClassroom" ? "fromClassroom" : fromCreateTest
                                        });
                                        if (listViewType == 'edit') {
                                            if (createTestModalSource != 'navigation') {
                                                history.push({
                                                    pathname: '/admin-test',
                                                    state: fromCreateTest
                                                });
                                            }
                                        }
                                        else {
                                            history.push({
                                                pathname: '/admin-test',
                                                state: location?.state?.key == "fromClassroom" ? "fromClassroom" : fromCreateTest
                                            });
                                        }
                                        createTestModal(createTestModalName, userType, '');
                                    };
                                    // POST /test only made the shell. Generated questions
                                    // go in one at a time through /test/test-question,
                                    // so wait for that before showing the paper.
                                    if (aiQuestions.length) {
                                        importAiQuestions(res, aiSnapshot, aiChapters, (summary) => {
                                            if (summary.skipped) {
                                                Notification.error(
                                                    'Some questions were left out',
                                                    `${summary.skipped} question${summary.skipped === 1 ? '' : 's'} of ${summary.skippedSubjects.join(', ')} were not added: the test has no such subject.`
                                                );
                                            }
                                            if (summary.failed) {
                                                Notification.error(
                                                    'Some questions were not added',
                                                    `${summary.created} of ${summary.created + summary.failed} questions were saved. Add the rest by hand.${summary.firstError ? ` Server said: ${summary.firstError}` : ''}`
                                                );
                                            } else if (summary.reassigned) {
                                                // Name the chapters the generator used, so a mismatch is
                                                // diagnosable instead of just reported as a number.
                                                const names = summary.unresolved?.length
                                                    ? ` The generator called them: ${summary.unresolved.join(', ')}.`
                                                    : '';
                                                Notification.success(
                                                    'Questions added',
                                                    `${summary.created} questions saved. ${summary.reassigned} were filed under the first chapter because their chapter did not match this syllabus.${names}`
                                                );
                                            }
                                            goToQuestions();
                                        });
                                    } else {
                                        goToQuestions();
                                    }
                                },
                                    () => {
                                        setCreateSaveLoader(false);
                                    }
                                    , sectionValue
                                );
                                setFromSectionMarkingScheme(false);
                                fromCreateNewButton(false)
                            }} >{createSaveLoader == true ? <></> : <PlusCircleOutlined />}CREATE</Button>
                    </div>
                </div>
            </div>
        )
    }
    const [section, includeSection] = useState(false)
    const [sectionMeta, setSectionMeta] = useState(null)
    const [searchText, setSearchText] = useState('');
    const [searchTextIndex, setSearchTextIndex] = useState('');
    const [handleRender, updateHandleRender] = useState(false);
    const [chapterSearchSubjectId, setChapterSearchSubjectId] = useState(null);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const location = useLocation();
    const isClassScreen = window.location.pathname == '/test-std-to-subjects-screen' ? true : false;
    // The handoff lives in the store and is only cleared by CANCEL/back, so
    // leaving through the sidebar leaves it behind. Only the Aulas AI and
    // Scan PDF flows arrive with their own from ('aulasAi' / 'scanPdf'); any
    // other entry (e.g. "Create test manually") must start without the prefill.
    const staleAiHandoff = !!aiHandoff?.active && !['aulasAi', 'scanPdf'].includes(location?.state?.from);
    useEffect(() => {
        if (staleAiHandoff) {
            clearGenerationSnapshot();
            clearTestCreateObj();
        } else if (createTestModalName === 'test-create' && testCreateObj.syllabus != undefined && testCreateObj.syllabus != '' && testCreateObj.subjectName?.length && testCreateObj.class != '' && testCreateObj.class != undefined) {
            getIndexOfTest();
        }
        getExaminer('');
        getSubjects('', isFromClassRoomDetails ? selectedSection?.id : isClassScreen ? selectedClassroom?.id : '');
    }, []);

    useEffect(() => {
        fetchMarkingSchemeData()
    }, [testCreateObj?.testType])

    // An AI prefill writes the subject straight into the store, so the side
    // effects that normally fire from the subject dropdown's onSelect never ran.
    // The batch list is the one that matters: without it the Batch dropdown is
    // enabled but empty, and the teacher cannot get any further.
    useEffect(() => {
        if (!aiHandoff?.active) return;
        if (!testCreateObj?.subjectId?.length) return;
        getTestClassList(testCreateObj.subjectId);
    }, [aiHandoff?.active, testCreateObj?.subjectId?.length])

    // Chapters can only be matched once a batch is chosen, because the chapter
    // list is scoped by standard. Picking a batch already fetches that list for
    // the chapter dropdown, so this matches against what is now in the store
    // rather than issuing a request of its own.
    // A batch whose subject has no chapters at all returns an empty list. Once
    // that request has finished, every generated chapter is unmatched -- which
    // is what brings up ADD THESE CHAPTERS -- instead of waiting forever.
    const chaptersLoading = !!loaders?.modalChapterLoader;
    const prevChaptersLoading = useRef(chaptersLoading);
    useEffect(() => {
        const chaptersJustLoaded = prevChaptersLoading.current && !chaptersLoading;
        prevChaptersLoading.current = chaptersLoading;
        if (!aiHandoff?.active) return;
        if (!aiHandoff?.pendingChapterNames?.length) return;
        if (!testCreateObj?.standardId?.length) return;
        if (chaptersForCreatingTest?.length) {
            resolveAiChapters(chaptersForCreatingTest);
        } else if (chaptersJustLoaded) {
            resolveAiChapters([], true);
        }
    }, [aiHandoff?.active, aiHandoff?.pendingChapterNames, testCreateObj?.standardId, chaptersForCreatingTest, chaptersLoading])

    // Every chapter was ticked in aulasAi, so the test is Full and the form does
    // not load chapters. The import still needs the batch's chapters to place
    // each question, so fetch them once per batch.
    const fullChaptersFetchedFor = useRef(null);
    useEffect(() => {
        if (!aiHandoff?.active || !aiHandoff?.fullSyllabus) return;
        if (testCreateObj?.syllabus !== 'Full' || !testCreateObj?.standardId?.length) return;
        const key = String(testCreateObj.standardId);
        if (fullChaptersFetchedFor.current === key) return;
        fullChaptersFetchedFor.current = key;
        getTestChapterList();
    }, [aiHandoff?.active, aiHandoff?.fullSyllabus, testCreateObj?.syllabus, testCreateObj?.standardId])

    useEffect(() => {
        if (handleRender) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                if (searchTextIndex === 'examiner') {
                    getExaminer(searchText)
                    updateHandleRender(false);
                } else if (searchTextIndex === 'chapters') {
                    getTestChapterList(searchText, chapterSearchSubjectId);
                    updateHandleRender(false);
                }
                else {
                    getSubjects(searchText, isFromClassRoomDetails ? selectedSection?.id : isClassScreen ? selectedClassroom?.id : '')
                    updateHandleRender(false);
                }
            }, 800);
        }
    }, [searchText, searchTextIndex, handleRender])
    const syllabusTypes = [{ id: 0, type: "Chapter" }, { id: 1, type: "Part" }, { id: 2, type: "Full" }]
    const timerDisable = (dependency) => {
        for (let x of dependency) {
            let bool = testCreateObj[x] === '' || testCreateObj[x] === 'Invalid date' || testCreateObj[x] == undefined
            if (bool) return true
        }
        return false
    }
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
    }
    const disabledResultDate = (current) => {
        return current && current < moment(testCreateObj?.heldDate, "DD/MM/YYYY").subtract(1, 'day').endOf('day');
    }
    const disabledStartTimeHours = () => {
        const hours = [];
        if (moment().format('DD/MM/YYYY') === testCreateObj?.heldDate) {
            for (var i = 0; i < moment().hour(); i++) {
                hours.push(i)
            }

        }
        return hours;
    };
    const disabledStartTimeMinutes = (selectedHour) => {
        var minutes = []
        if (selectedHour === moment().hour()) {
            for (var i = 0; i <= moment().minute(); i++) {
                minutes.push(i);
            }
        }
        return minutes;
    }
    const disabledEndTimeHours = () => {
        const hours = [];
        for (var i = 0; i < moment(testCreateObj?.heldStartTime, 'HH:mm:ss').hour(); i++) {
            hours.push(i);
        }
        return hours
    }
    const disabledEndTimeMinutes = (selectedHour) => {
        const minutes = [];
        if (selectedHour === moment(testCreateObj.heldStartTime, 'HH:mm:ss').hour()) {
            for (var i = 0; i <= moment(testCreateObj.heldStartTime, 'HH:mm:ss').minute(); i++) {
                minutes.push(i);
            }
        }
        return minutes;
    }
    const disabledResultTimeHours = () => {
        const hours = [];
        if (testCreateObj.heldDate === testCreateObj.resultDate) {
            for (var i = 0; i < moment(testCreateObj.heldEndTime, 'HH:mm:ss').hour(); i++) {
                hours.push(i)
            }
        }
        return hours
    }
    const disabledResultTimeMinutes = (selectedHour) => {
        const minutes = [];
        if (testCreateObj.heldDate === testCreateObj.resultDate && selectedHour === moment(testCreateObj.heldEndTime, 'HH:mm:ss').hour()) {
            for (var i = 0; i <= moment(testCreateObj.heldEndTime, 'HH:mm:ss').minute(); i++) {
                minutes.push(i)
            }
        }
        return minutes
    }
    const subjectSectionOnChange = (mainIndex, value) => {
        setSubjectSectionAction([...storeSubjectSection?.slice(0, mainIndex), value, ...storeSubjectSection?.slice(mainIndex + 1)])
    }
    const selectSubject = (value) => {
        storeCreateTestModalData('subjects', { name: value.value, id: value.key });
        setSubjectSectionAction([...storeSubjectSection, { name: value.value, id: value.key }])
    }
    const removeSelectedSubject = (id) => {
        let temp = storeSubjectSection
        temp?.splice(id, 1);
        setSubjectSectionAction([...temp])
    }
    return (
        <div style={bodyStyle}>
            <PageHeader />
            <PageDataLoader visible={createSaveLoader || !!loaders?.aiImportLoader} />
            <ConfigProvider getPopupContainer={(triggerNode) => triggerNode ? (triggerNode.parentNode || triggerNode.parentElement) : document.body}>
                <div className='m-t-30' style={{ overflowY: "scroll", height: "calc(100% + -80px)" }}>
                    <div style={{ padding: "0px 100px 140px 100px" }}>
                        <AiPrefillBanner
                            aiHandoff={aiHandoff}
                            importProgress={loaders?.aiImportProgress}
                            creatingChapters={!!loaders?.aiChapterCreateLoader}
                            onOpenAddSubjectModal={() => handleOpenAddSubjectModal()}
                            onAddMissingSubject={handleOpenAddSubjectModal}
                            subjectsWithoutChapters={subjectsWithoutChapters}
                            onAddTopicChapters={handleAddTopicChapters}
                            onCreateChapters={handleCreateChapters}
                        />
                        <Modal
                            title={`Add Subject "${subjectNameToAdd}" to a Batch`}
                            visible={isAddSubjectModalVisible}
                            onCancel={() => { setAddSubjectModalVisible(false); setMissingSubjectToAdd(null); }}
                            footer={[
                                <Button key="cancel" onClick={() => { setAddSubjectModalVisible(false); setMissingSubjectToAdd(null); }}>
                                    Cancel
                                </Button>,
                                <Button
                                    key="submit"
                                    type="primary"
                                    loading={!!loaders?.aiSubjectCreateLoader}
                                    disabled={!selectedBatchForSubject}
                                    onClick={handleCreateSubjectSubmit}
                                >
                                    Add Subject & Select
                                </Button>
                            ]}
                        >
                            <div style={{ marginBottom: 15 }}>
                                <div style={{ fontWeight: 600, marginBottom: 5 }}>Subject Name</div>
                                <Input value={subjectNameToAdd} disabled />
                            </div>
                            {missingSubjectToAdd?.topics?.length > 0 && (
                                <div style={{ marginBottom: 15, fontSize: 12, color: '#636363' }}>
                                    Its generated topics are added as its chapters, so its questions can be saved:{' '}
                                    {missingSubjectToAdd.topics.join(', ')}.
                                </div>
                            )}
                            <div>
                                <div style={{ fontWeight: 600, marginBottom: 5 }}>
                                    Select Batch <span style={{ color: 'red' }}>*</span>
                                </div>
                                <div className="dropdown-relative-container">
                                    <Select
                                        showSearch
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            String(option?.children || '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        style={{ width: '100%' }}
                                        placeholder="Choose batch / class"
                                        value={selectedBatchForSubject}
                                        onChange={(val, option) => {
                                            setSelectedBatchForSubject(val);
                                            setSelectedBatchLabelForSubject(option?.children || `${val}`);
                                        }}
                                        loading={loadingBatches}
                                    >
                                        {availableBatches?.map((b) => {
                                            const label = b.std && b.section
                                                ? `${b.std} - ${b.section}${b.courseName ? ` (${b.courseName})` : ''}`
                                                : b.courseName || `Batch ${b.id}`;
                                            return (
                                                <Option key={b.id} value={b.id}>
                                                    {label}
                                                </Option>
                                            );
                                        })}
                                    </Select>
                                </div>
                            </div>
                        </Modal>
                        {aiHandoff?.active ? (
                            // Locked to the type picked on the generation review screen:
                            // Objective, or Subjective / Mixed for a CBSE Board set.
                            <div>
                                <div className='bold-600 text-xmd' style={{ color: '#636363', marginBottom: 5 }}>
                                    Question type <span style={{ color: 'red' }}>*</span>
                                </div>
                                <Select
                                    disabled
                                    className='test-custom-select createTestModalValue'
                                    style={{ width: '100%', borderRadius: 5 }}
                                    value={testCreateObj?.testType || 'Objective'}
                                    bordered={true}>
                                    <Option value="Objective">Objective type questions</Option>
                                    <Option value="Subjective">Subjective type questions</Option>
                                    <Option value="Mixed">Mixed (objective + subjective questions)</Option>
                                </Select>
                            </div>
                        ) : (
                            <div>
                                <div className='bold-600 text-xmd' style={{ color: '#636363', marginBottom: 5 }}>Question type <span style={{ color: 'red' }}>*</span></div>
                                <div className="dropdown-relative-container">
                                    <Select
                                        placeholder="Choose test type"
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        className='test-custom-select createTestModalValue'
                                        style={{ width: '100%', borderRadius: 5 }}
                                        onChange={(value) => { storeCreateTestModalData('testType', value) }}
                                        value={testCreateObj?.testType === "" ? null : testCreateObj?.testType}
                                        bordered={true}>
                                        <Option value="Objective">Objective type questions</Option>
                                        <Option value="Subjective">Subjective type questions</Option>
                                        <Option value="Mixed">Mixed (objective + subjective questions)</Option>
                                        <Option value="Coding">Coding questions</Option>
                                    </Select>
                                </div>
                            </div>
                        )}
                        <div className='m-t-20'>
                            <div className='text-xmd bold-600 m-b-5 m-t-20' style={{ color: '#636363' }}>Title <span style={{ color: 'red' }}>*</span></div>
                            <Input value={testCreateObj?.title} onChange={(e) => storeCreateTestModalData('title', e.target.value)} style={{ borderRadius: 5, width: '100%' }} placeholder="Enter title" bordered={true} />
                        </div>
                        <div className='r-jsb m-t-20' style={{ width: '100%' }}>
                            <div className='flex-1 m-r-20'>
                                <div className='bold-600 text-xmd' style={{ color: '#636363', marginBottom: 5 }}>Examiner <span style={{ color: 'red' }}>*</span></div>
                                <div className="dropdown-relative-container">
                                    <Select
                                        allowClear={true}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        disabled={user?.name === testCreateObj?.teacherName}
                                        className="m-b-15 test-custom-select createTestModalValue"
                                        style={{ width: '100%', minWidth: '40%' }}
                                        placeholder={"Search examiner(Teacher)"}
                                        showSearch
                                        loading={getExaminerBool}
                                        value={(testCreateObj?.teacherName == '' || testCreateObj?.teacherName == undefined) ? null : testCreateObj?.teacherName}
                                        showArrow={userType == 'teacher' ? false : true}
                                        filterOption={false}
                                        defaultActiveFirstOption={false}
                                        notFoundContent={null}
                                        onSearch={(text) => { setSearchText(text); setSearchTextIndex('examiner'); updateHandleRender(true) }}
                                        onChange={(text, value) => { value ? storeCreateTestModalData('examiner', { name: value.value, id: value.key }) : getExaminer('') }}
                                    >
                                        {!getExaminerBool && getExaminerArr?.map((item) => {
                                            //   if (item?.id != testCreateObj?.teacherId) {
                                            return <Option key={item?.id} className="createTestModalDropdown" value={item.value}>{item.value}</Option>
                                            //   }
                                            return null
                                        })}
                                    </Select>
                                </div>
                            </div>
                            <div className='flex-1'>
                                <div className='bold-600 text-xmd' style={{ color: '#636363', marginBottom: 5 }}>Syllabus <span style={{ color: 'red' }}>*</span></div>
                                <div className="dropdown-relative-container">
                                    <Select
                                        disabled={aiHandoff?.active ? true : false}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        className="m-b-15 test-custom-select createTestModalValue"
                                        style={{ width: '100%', minWidth: '40%', color: testCreateObj?.syllabus === '' ? '#a2a2a2' : '', cursor: aiHandoff?.active ? 'not-allowed' : undefined }}
                                        placeholder={"Select syllabus"}
                                        filterOption={false}
                                        value={(testCreateObj?.syllabus === '' || testCreateObj?.syllabus == undefined) ? null : testCreateObj?.syllabus}
                                        onChange={(value) => {
                                            if (aiHandoff?.active) return;
                                            storeCreateTestModalData('syllabus', value);
                                            if (!isClassScreen) {
                                                storeCreateTestModalData('class', '');
                                            }
                                            storeCreateTestModalData('clearsubjects', null);
                                            storeCreateTestModalData('clearchapters', null);
                                            storeCreateTestModalData('tIndex', 0);
                                            getSubjects('', isFromClassRoomDetails ? selectedSection?.id : isClassScreen ? selectedClassroom?.id : '');
                                            includeSection(false);
                                            setSubjectSectionAction([])
                                        }}
                                        notFoundContent={null}>
                                        {syllabusTypes?.map((item, index) => (
                                            <Option key={item.id} value={item.type} className="createTestModalDropdown">{item.type}</Option>
                                        ))}
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className='r-jsb' style={{ width: '100%' }}>
                                <div className='bold-600 text-xmd' style={{ color: '#636363', marginBottom: 5 }}>Subject(s) <span style={{ color: 'red' }}>*</span></div>
                                <div className='display-flex'>
                                    {/* Show sections only if include sections is checked */}
                                    <Checkbox disabled={aiHandoff?.active} checked={section} onChange={(e) => {
                                        if (aiHandoff?.active) return;
                                        includeSection(e.target.checked)
                                        setSectionValue(e.target.checked);
                                    }}></Checkbox>
                                    <div className='text-xs m-l-5 m-t-5' style={{ color: '#191919' }}>Include sections</div>
                                </div>
                            </div>
                            <div className="dropdown-relative-container">
                                <Select
                                    showSearch
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    disabled={(aiHandoff?.active || testCreateObj?.syllabus == undefined || testCreateObj?.syllabus === "" || (createTestModalName === 'test-edit' && testCreateObj?.totalQuestions > 0) || (createTestModalName === 'test-clone') || (testCreateObj.syllabus === 'Chapter' && testCreateObj.subjectName?.length >= 1) || (singleSubjectOnly(testCreateObj.testType) && testCreateObj.subjectName?.length >= 1)) ? true : false}
                                    className='test-custom-select createTestModalValue'
                                    style={{ width: '100%', color: "#AEAEAE", cursor: aiHandoff?.active ? 'not-allowed' : undefined }}
                                    placeholder={"Select subject(s)"}
                                    defaultActiveFirstOption={false}
                                    filterOption={false}
                                    showArrow={true}
                                    loading={loaders?.modalSubjectLoader}
                                    value={null}
                                    onSearch={(text) => { setSearchText(text); setSearchTextIndex('subjects'); updateHandleRender(true) }}
                                    notFoundContent="No subject found"
                                    onSelect={(text, value) => {
                                        if (aiHandoff?.active) return;
                                        storeCreateTestModalData('clearchapters', null);
                                        if (!testCreateObj?.subjectId?.includes(value.key)) {
                                            //   storeCreateTestModalData('subjects', { name: value.value, id: value.key });
                                            selectSubject(value)
                                            if (!isClassScreen) {
                                                storeCreateTestModalData('class', '');
                                            }
                                            else {
                                                getIndexOfTest();
                                            }
                                            getTestClassList(testCreateObj.subjectId ?? []);
                                            fetchMarkingSchemeData()
                                            if (isClassScreen && (testCreateObj.syllabus !== 'Full' || aiHandoff?.active)) { // an imported Full test still needs its chapters, to file each question
                                                getTestChapterList();
                                            }
                                        }
                                        console.log("testCreateObj", testCreateObj)

                                    }}
                                >
                                    {!getSubjectsBool && getSubjectsArr?.map((item, index) => {
                                        if (!testCreateObj?.subjectId?.includes("" + item.id)) {
                                            return <Option className="createTestModalDropdown" key={item?.id} value={item?.value}>{item?.value}</Option>
                                        } else {
                                            return null
                                        }
                                    })}
                                </Select>
                            </div>
                            {typeof testCreateObj?.subjectName !== 'string' ?
                                <>
                                    {testCreateObj?.subjectName?.length
                                        ?
                                        <div className='flex-wrap r-ac'>
                                            {testCreateObj.subjectName?.map((item, index) => (
                                                <div key={index} className={`shadow-box white p-l-10 p-r-10 p-t-5 p-b-5 m-r-15 m-t-15 r-ac ${aiHandoff?.active ? 'ai-prefilled-tag' : ''}`} style={{ background: '#594099', cursor: aiHandoff?.active ? 'not-allowed' : 'default' }}>
                                                    <div className='text-xs'>{item}</div>
                                                    {
                                                        (createTestModalName === 'test-edit' && testCreateObj.totalQuestions > 0) || createTestModalName === 'test-clone' || aiHandoff?.active
                                                            ?
                                                            null
                                                            :
                                                            <AiOutlineClose onClick={((createTestModalName === 'test-edit' && testCreateObj.totalQuestions > 0) || (createTestModalName === 'test-clone'))
                                                                ?
                                                                () => { }
                                                                :
                                                                () => {
                                                                    removeSelectedSubject(index)
                                                                    storeCreateTestModalData('removesubjectchapters', index);
                                                                    if (testCreateObj?.class !== 0 && testCreateObj?.subjectId?.length !== 1) {
                                                                        getIndexOfTest();
                                                                    }
                                                                    if (testCreateObj?.subjectId?.length > 1) {
                                                                        getTestClassList(testCreateObj?.subjectId ?? []);
                                                                        fetchMarkingSchemeData()
                                                                        getTestChapterList();
                                                                    }
                                                                    if (createTestModalSource !== 'class' && testCreateObj?.subjectId?.length === 1) {
                                                                        storeCreateTestModalData('class', '');
                                                                        storeCreateTestModalData('tIndex', 0);
                                                                    }
                                                                    removeSelectedSearchSubjs(index, 'removeOne');
                                                                }}
                                                                className='m-l-10 text-xs cursor-pointer' />
                                                    }
                                                </div>
                                            ))}
                                        </div>
                                        : null
                                    }
                                </>
                                :
                                null
                            }
                        </div>
                        <div className='r-jsb m-t-20' style={{ width: '100%' }}>
                            <div className='flex-1 m-r-20'>
                                <div className='bold-600 text-xmd' style={{ color: '#636363', marginBottom: 5 }}>Batch <span style={{ color: 'red' }}>*</span></div>
                                <div className="dropdown-relative-container">
                                    <Select
                                        disabled={((createTestModalName !== 'test-clone') && (isClassScreen || (createTestModalName === 'test-edit' && testCreateObj.totalQuestions > 0)
                                            || testCreateObj?.subjectName?.length === 0)
                                        ) ? true : false}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        onChange={(text, value) => {
                                            if (createTestModalName !== 'test-clone') {
                                                storeCreateTestModalData('clearchapters', null);
                                            }
                                            storeCreateTestModalData('standardId', value.key);
                                            storeCreateTestModalData('class', value.value);
                                            getIndexOfTest();
                                            if (createTestModalName !== 'test-clone' && (testCreateObj?.syllabus !== 'Full' || aiHandoff?.active)) { // an imported Full test still needs its chapters, to file each question
                                                getTestChapterList();
                                            }
                                        }}
                                        loading={loaders?.modalClassLoader && !isClassScreen}
                                        value={testCreateObj?.class === '' ? 'Select batch' : isFromClassRoomDetails ? `${selectedSection.std + ' - ' + selectedSection.section}` : testCreateObj?.class}
                                        className="m-b-15 test-custom-select createTestModalValue"
                                        style={{ width: '100%', minWidth: '40%' }}
                                        placeholder={"Search batch"}
                                        filterOption={false}
                                        notFoundContent="No data found"
                                    >
                                        {stdsForCreatingTest?.map((item, index) => (
                                            <Option className="createTestModalDropdown" key={item.id} value={`${item?.std} - ${item?.section}`}>{`${item?.std} - ${item?.section}`}</Option>
                                        ))}
                                    </Select>
                                </div>
                            </div>
                            <div className='flex-1'>
                                <div className='bold-600 text-xmd' style={{ color: '#636363', marginBottom: 5 }}>Index</div>
                                <Input
                                    value={testCreateObj?.tIndex === '' ? 0 : testCreateObj?.tIndex}
                                    className="m-b-15 test-custom-select createTestModalValue"
                                    style={{ width: '100%', minWidth: '40%', borderRadius: 5 }}
                                    readOnly
                                    disabled={true} />
                            </div>
                        </div>
                        <div className='bold-700 text-xmd m-t-20'>Test to be held on</div>
                        <div className='r-jsb m-t-10' style={{ width: '100%' }}>
                            <div className='flex-1 m-r-20'>
                                <div className='bold-600 text-xmd' style={{ color: '#636363', marginBottom: 5 }}>Date <span style={{ color: 'red' }}>*</span></div>
                                <div className="dropdown-relative-container">
                                    <DatePicker
                                        format='DD/MM/YYYY'
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        className="createmodalbg"
                                        style={{ width: '100%', minWidth: '40%' }}
                                        dropdownClassName='legend-range-calendar-drpdwn'
                                        placeholder={"Set date"}
                                        defaultValue={testCreateObj?.heldDate === '' || testCreateObj?.heldDate === 'Invalid date' || testCreateObj?.heldDate === undefined ? '' : moment(testCreateObj?.heldDate, 'DD/MM/YYYY')}
                                        showToday={false}
                                        allowClear={false}
                                        onChange={(e, date) => { storeCreateTestModalData('heldDate', date); selectedTestStartTime = date }}
                                        disabledDate={disabledDate}
                                    />
                                </div>
                            </div>
                            <div className='flex-1'>
                                <div className='bold-600 text-xmd' style={{ color: '#636363', marginBottom: 5 }}>Start time <span style={{ color: 'red' }}>*</span></div>
                                <div className="dropdown-relative-container">
                                    <TimePicker
                                        minuteStep={10}
                                        showNow={false}
                                        format={'HH:mm'}
                                        inputReadOnly={true}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        disabled={timerDisable(['heldDate'])}
                                        style={{ width: '100%', minWidth: '40%' }}
                                        disabledMinutes={disabledStartTimeMinutes}
                                        disabledHours={disabledStartTimeHours}
                                        className="m-b-5 test-custom-select createTestModalValue createmodalbg"
                                        defaultValue={testCreateObj?.heldStartTime === '' ? '' : moment(testCreateObj?.heldStartTime, 'HH:mm:ss')}
                                        onChange={(e, time) => {
                                            storeCreateTestModalData('heldStartTime', moment(time, 'HH:mm').format('HH:mm:ss'));
                                            if (time != testCreateObj?.heldStartTime) {
                                                storeCreateTestModalData('heldEndTime', '')
                                                storeCreateTestModalData('resultTime', '')
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='flex-1 m-l-20'>
                                <div className='bold-600 text-xmd' style={{ color: '#636363', marginBottom: 5 }}>End time <span style={{ color: 'red' }}>*</span></div>
                                <div className="dropdown-relative-container">
                                    <TimePicker
                                        value={(testCreateObj?.heldEndTime === '' || testCreateObj?.heldEndTime === 'Invalid date' || testCreateObj?.heldEndTime === undefined) ? '' : moment(testCreateObj?.heldEndTime, 'HH:mm:ss')}
                                        minuteStep={10}
                                        format={'HH:mm'}
                                        showNow={false}
                                        inputReadOnly={true}
                                        placeholder={"Set time"}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        disabledHours={() => disabledEndTimeHours()}
                                        disabledMinutes={disabledEndTimeMinutes}
                                        style={{ width: '100%', minWidth: '40%' }}
                                        disabled={timerDisable(['heldDate', 'heldStartTime'])}
                                        className="m-b-5 test-custom-select createTestModalValue createmodalbg"
                                        onChange={(e, time) => storeCreateTestModalData('heldEndTime', moment(time, 'HH:mm').format('HH:mm:ss'))}
                                    />
                                </div>
                            </div>
                        </div>
                        {hidesResultDate(testCreateObj.testType)
                            ?
                            null
                            :
                            <>
                                <div className='bold-700 text-xmd m-t-20'>Result to be published on </div>
                                <div className='r-jsb m-t-10' style={{ width: '100%' }}>
                                    <div className='flex-1 m-r-20'>
                                        <div className='bold-600 text-xmd' style={{ color: '#636363', marginBottom: 5 }}>Date <span style={{ color: 'red' }}>*</span></div>
                                        <div className="dropdown-relative-container">
                                            <DatePicker
                                                format='DD/MM/YYYY'
                                                allowClear={false}
                                                showToday={false}
                                                placeholder={"Set date"}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                disabledDate={disabledResultDate}
                                                style={{ width: '100%', minWidth: '40%' }}
                                                dropdownClassName='legend-range-calendar-drpdwn'
                                                className="m-b-15 test-custom-select createTestModalValue"
                                                onChange={(e, date) => { storeCreateTestModalData('resultDate', date) }}
                                                disabled={timerDisable(['heldDate', 'heldStartTime', 'heldEndTime'])}
                                                defaultValue={testCreateObj?.resultDate === '' || testCreateObj?.heldDate === 'Invalid date' || testCreateObj?.heldDate === undefined ? '' : moment(testCreateObj?.resultDate, 'DD/MM/YYYY')}
                                            />
                                        </div>
                                    </div>
                                    <div className='flex-1'>
                                        <div className='bold-600 text-xmd' style={{ color: '#636363', marginBottom: 5 }}>Time <span style={{ color: 'red' }}>*</span></div>
                                        <div className="dropdown-relative-container">
                                            <TimePicker
                                                value={testCreateObj?.resultTime === '' ? '' : moment(testCreateObj?.resultTime, 'HH:mm:ss')}
                                                allowClear={false}
                                                showNow={false}
                                                minuteStep={10}
                                                format={'HH:mm'}
                                                inputReadOnly={true}
                                                placeholder={"Set time"}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                style={{ width: '100%', minWidth: '40%' }}
                                                disabledMinutes={disabledResultTimeMinutes}
                                                disabledHours={() => disabledResultTimeHours()}
                                                className="m-b-15 test-custom-select createTestModalValue createmodalbg"
                                                disabled={timerDisable(['heldDate', 'heldStartTime', 'heldEndTime', 'resultDate'])}
                                                defaultValue={testCreateObj?.resultTime === '' ? '' : moment(moment(testCreateObj?.resultTime, "HH:mm A").format("HH:mm"), "HH:mm:ss")}
                                                onChange={(e, time) => storeCreateTestModalData('resultTime', moment(time, 'HH:mm').format('HH:mm:ss'))}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        <div>
                            <div className='bold-600 text-xmd' style={{ color: '#636363', marginBottom: 5 }}>Instructions <span style={{ color: 'red' }}>*</span></div>
                            <TextArea
                                style={{ width: '100%' }}
                                defaultValue={testCreateObj?.instruction}
                                value={testCreateObj?.instruction}
                                placeholder="Add Instructions"
                                className='test-custom-select createTestModalValue'
                                onChange={(e) => storeCreateTestModalData('instruction', e.target.value)}
                            />
                        </div>
                        {typeof testCreateObj?.subjectName !== 'string' ?
                            <>
                                {testCreateObj?.subjectName?.map((item, mainIndex) => {
                                    return <SubjectSectionsCard
                                        id={testCreateObj?.subjectId?.[mainIndex]}
                                        item={item}
                                        testCreateObj={testCreateObj}
                                        groupedChapters={groupedChapters}
                                        setChapterSearchSubjectId={setChapterSearchSubjectId}
                                        setSearchText={setSearchText}
                                        setSearchTextIndex={setSearchTextIndex}
                                        updateHandleRender={updateHandleRender}
                                        storeCreateTestModalData={storeCreateTestModalData}
                                        searchedGroupedChapters={searchedGroupedChapters}
                                        createTestModalName={createTestModalName}
                                        removeSelectedChapter={removeSelectedChapter}
                                        section={section}
                                        mainIndex={mainIndex}
                                        storeSubjectSection={storeSubjectSection[mainIndex]}
                                        subjectSectionOnChange={subjectSectionOnChange}
                                        storeMarkingSchemeRes={storeMarkingSchemeRes}
                                        fetchMarkingSchemeData={fetchMarkingSchemeData}
                                        loaders={loaders}
                                        setIsPreviewModalOpen={setIsPreviewModalOpen}
                                        fromCreateNewButton={fromCreateNewButton}
                                        setFromSectionMarkingScheme={setFromSectionMarkingScheme}
                                        storeMarkedSchemeCardId={storeMarkedSchemeCardId}
                                        aiHandoff={aiHandoff}
                                        onCreateChapters={handleCreateChapters}
                                        creatingChapters={!!loaders?.aiChapterCreateLoader}
                                    />
                                })
                                }
                            </>
                            :
                            null
                        }
                    </div>
                </div>
            </ConfigProvider>
            {isPreviewModalOpen &&
                <PreviewTestModal
                    isModalOpen={isPreviewModalOpen}
                    setIsModalOpen={setIsPreviewModalOpen}
                />
            }
        </div>
    )
}


const mapStateToProps = state => {
    const { testCreateObj, getExaminerArr, getExaminerBool, getSubjectsBool, getSubjectsArr,
        universalLoaderBool, getIndexOfTestBool, stdsForCreatingTest, createTestModalBool, createTestModalName,
        generateQuesObj, userType, selectedTest, listViewType, createTestModalSource, selectedClassroomId, chaptersForCreatingTest,
        selectedClassroom, loaders, groupedChapters, searchedGroupedChapters, storeSubjectSection, storeMarkingSchemeRes, aiHandoff } = state.testAdmin;
    const { user } = state.session;
    const { isFromClassRoomDetails, selectedSection } = state.classRoom
    return {
        testCreateObj, getExaminerArr, getExaminerBool, getSubjectsBool, getSubjectsArr,
        universalLoaderBool, getIndexOfTestBool, stdsForCreatingTest, createTestModalBool, createTestModalName,
        generateQuesObj, userType, selectedTest, listViewType, createTestModalSource, selectedClassroomId, chaptersForCreatingTest,
        selectedClassroom, loaders, groupedChapters, searchedGroupedChapters, storeSubjectSection, storeMarkingSchemeRes, user, isFromClassRoomDetails, selectedSection, aiHandoff
    };
};

const mapDispatchToProps = dispatch => ({
    storeCreateTestModalData: (key, value) => dispatch(storeCreateTestModalData(key, value)),
    getSubjects: (text, standardId) => dispatch(getSubjects(text, standardId)),
    getExaminer: (text) => dispatch(getExaminer(text)),
    removeSelectedSearchSubjs: (index, text) => dispatch(removeSelectedSearchSubjs(index, text)),
    postTestCreate: (callback, success, sectionValue) => dispatch(postTestCreate(callback, success, sectionValue)),
    getIndexOfTest: () => dispatch(getIndexOfTest()),
    createTestModal: (name, userType, source) => dispatch(createTestModal(name, userType, source)),
    showGenerateQuesListView: (callback, pagesource) => dispatch(showGenerateQuesListView(callback, pagesource)),
    updateSelectedCardType: (type) => dispatch(updateSelectedCardType(type)),
    getTestClassList: (classIds) => dispatch(getTestClassList(classIds)),
    getTestChapterList: (search, subId, iscreate, stdid) => dispatch(getTestChapterList(search, subId, iscreate, stdid)),
    removeSelectedChapter: (id) => dispatch(removeSelectedChapter(id)),
    setSubjectSectionAction: (val) => dispatch(setSubjectSectionAction(val)),
    fetchMarkingSchemeData: () => dispatch(fetchMarkingSchemeData()),
    clearTestCreateObj: () => dispatch(clearTestCreateObj()),
    fromCreateNewButton: (bool) => dispatch(fromCreateNewButton(bool)),
    setFromSectionMarkingScheme: (val) => dispatch(setFromSectionMarkingScheme(val)),
    storeMarkedSchemeCardId: (val) => dispatch(storeMarkedSchemeCardId(val)),
    resolveAiChapters: (available, loadedEmpty) => dispatch(resolveAiChapters(available, loadedEmpty)),
    importAiQuestions: (test, handoff, chapters, callback) =>
        dispatch(importAiQuestions(test, handoff, chapters, callback)),
    createAiChapters: (callback, customSubjectId) => dispatch(createAiChapters(callback, customSubjectId)),
    createAiSubject: (subjectName, standardId, standardLabel, callback, options) =>
        dispatch(createAiSubject(subjectName, standardId, standardLabel, callback, options)),
    createAiSubjectChapters: (subjectId, standardId, topics, callback) =>
        dispatch(createAiSubjectChapters(subjectId, standardId, topics, callback)),
    fetchAllInstituteStandards: (callback) =>
        dispatch(fetchAllInstituteStandards(callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateTest); 
